import Link from "next/link";
import { useRef } from "react";

import Cta from "@/components/atoms/Cta/Cta";

import * as S from "./LandingPageLifeOrganism.style";

export let lastCtaRef;
const LandingPageLifeOrganism = ({
  course,
  title,
  ctaText,
  ctaHandler,
}: {
  course: string;
  title: JSX.Element;
  ctaText: string;
  ctaHandler: ({ button_text, location }) => void;
}) => {
  lastCtaRef = useRef();

  function clickCta() {
    ctaHandler({ button_text: ctaText, location: "bottom" });
  }

  return (
    <S.Wrapper ref={lastCtaRef}>
      <S.Title>{title}</S.Title>
      {/*<Link href={`/apply?course=${course}`} passHref>*/}
      {/*  <a>*/}
      <Cta onClick={clickCta}>{ctaText}</Cta>
      {/*</a>*/}
      {/*</Link>*/}
    </S.Wrapper>
  );
};

export default LandingPageLifeOrganism;
